// Interface

import util from '@/utils/classToObject'
import { IDebugState } from './state'

export class DebugGetter {
  public debugItems(state: IDebugState) {
    return state.items
  }
  
  public debugStatus(state: IDebugState) {
    return state.debugStatus
  }

  public debugEnable(state: IDebugState) {
    return state.debugEnable
  }

  public debugFilter(state: IDebugState) {
    return state.debugFilter
  }
  
}

export default util.classToObject(DebugGetter)
